import { useState } from 'react'
import { useTranslations } from '@/lib/next-shim'

import { Typography } from '@mui/material'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'

export type VideoViewerProps = {
  onError?: (error?: unknown) => void
  src: string
  fallBackSrc?: string
}
export default function VideoViewer(props: VideoViewerProps) {
  const t = useTranslations()

  const { src, onError, fallBackSrc } = props
  const [videoSrc, setVideoSrc] = useState<string>(src)
  const [error, setError] = useState<boolean>(false)
  const handleError = () => {
    if (!fallBackSrc) return
    setVideoSrc(fallBackSrc)
    setError(true)
    onError?.()
  }

  return (
    <Stack alignItems="center" spacing={2} sx={{ width: '100%' }}>
      <Box
        sx={[
          { width: '100%' },
          error && {
            width: '200px',
          },
        ]}
      >
        <video src={videoSrc} controls autoPlay onError={handleError} width="100%"></video>
      </Box>
      {error && (
        <Typography variant="subtitle1" component="div">
          {t('ui.filePreview.VideoViewer.notAvailable')}
        </Typography>
      )}
    </Stack>
  )
}
